<template>
  <event-management
    :get-roles="getRoles"
    :get-categories="getCategories"
    :get-event="getEvent"
    :save-event="saveEvent"
    :update-event="updateEvent"
    :exist-sie="existSie"
    :get-applications="getApplications"
    :component-options="componentOptions"
  />
</template>

<script>
import { EventManagement } from "operations";
import _service from "@/modules/operation-calendar-event/api.js";
import { getApplications } from "@/modules/common/code.api.js";

export default {
  name: "EventManagementWrapper",
  components: { EventManagement },
  methods: {
    getRoles() {
      return _service.fetchRol();
    },
    getCategories() {
      return _service.fetchCategory();
    },
    getEvent(id) {
      return _service.fetchEventById(id);
    },
    saveEvent(params) {
      return _service.saveEvent(params);
    },
    existSie(params) {
      return _service.existSieById(params);
    },
    updateEvent(params) {
      return _service.updateEvent(params);
    },
    getApplications() {
      return getApplications();
    }
  },
  computed: {
    componentOptions() {
      return {
        descriptionTextarea: {
          maxlength: 600,
        }
      };
    },
  },
  computed: {
    componentOptions() {
      return {
        descriptionTextarea: {
          maxlength: 600,
        }
      };
    },
  },
};
</script>
